import { TextField, InputLabel } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

export const CustomDatePicker = ({
  selectedDate,
  handleDateChange,
  handleClearDate,
  isDateSelected = true,
  inputLabel = "Required Date",
  size = "small",
  max_width = "400px",
  height = "auto",
  maxDate,          
}) => {
  return (
    <>
      <InputLabel
        style={{
          position: "absolute",
          marginLeft: "20px",
          marginTop: "-20px",
        }}>
        {inputLabel}
      </InputLabel>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Stack direction="row" spacing={1}>
          <DesktopDatePicker
            label="Required Date"
            slotProps={{ textField: { size: size } }}
            inputFormat="dd/MM/yyyy"
            value={selectedDate}
            onChange={handleDateChange}
            maxDate={maxDate}   
            renderInput={({ inputRef, inputProps, InputProps }) => (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "5%",
                  marginBottom: "0%",
                  width: "100%",
                  maxWidth: max_width,
                  height: height,
                  minWidth: "200px",
                  position: "relative",
                }}>
                <TextField
                  inputRef={inputRef}
                  style={{
                    width: "100%",
                    backgroundColor: "#fff",
                  }}
                  name="order_date"
                  value={selectedDate}
                  onChange={handleDateChange}
                  {...inputProps}
                  InputProps={{
                    ...InputProps,
                    endAdornment: selectedDate &&
                      isDateSelected &&
                      handleClearDate && (
                        <IconButton
                          onClick={handleClearDate}
                          size="small"
                          style={{
                            position: "absolute",
                            right: "50px",
                            color: "red",
                          }}>
                          <ClearIcon />
                        </IconButton>
                      ),
                  }}
                />
                <span style={{ position: "absolute", right: "10px" }}>
                  {InputProps?.endAdornment}
                </span>
              </Box>
            )}
          />
        </Stack>
      </LocalizationProvider>
    </>
  );
};